import { render, staticRenderFns } from "./channelQuery.vue?vue&type=template&id=19b64033&scoped=true&"
import script from "./channelQuery.vue?vue&type=script&lang=js&"
export * from "./channelQuery.vue?vue&type=script&lang=js&"
import style0 from "./channelQuery.vue?vue&type=style&index=0&id=19b64033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b64033",
  null
  
)

export default component.exports